import http from './api'

const route = 'app/financeiro/fluxo-caixa/'

export default {
  showSaldoBancario: (username, tokenContrato, select) => {
    return http.post(route + 'showSaldoBancario', {
      username: username,
      tokenContrato: tokenContrato,
      select: select,
    })
  },

  showSaldoContas: (username, tokenContrato, select) => {
    return http.post(route + 'showSaldoContas', {
      username: username,
      tokenContrato: tokenContrato,
      select: select,
    })
  },

  showGraficoProjecaoFinanceira: (username, tokenContrato, select) => {
    return http.post(route + 'showGraficoProjecaoFinanceira', {
      username: username,
      tokenContrato: tokenContrato,
      select: select,
    })
  },

  showProjecaoFinanceira7Dias: (username, tokenContrato, select) => {
    return http.post(route + 'showProjecaoFinanceira7Dias', {
      username: username,
      tokenContrato: tokenContrato,
      select: select,
    })
  },

  showProjecaoFinanceira15Dias: (username, tokenContrato, select) => {
    return http.post(route + 'showProjecaoFinanceira15Dias', {
      username: username,
      tokenContrato: tokenContrato,
      select: select,
    })
  },

  showProjecaoFinanceira30Dias: (username, tokenContrato, select) => {
    return http.post(route + 'showProjecaoFinanceira30Dias', {
      username: username,
      tokenContrato: tokenContrato,
      select: select,
    })
  },

  showProjecaoReceber7Dias: (username, tokenContrato, select) => {
    return http.post(route + 'showProjecaoReceber7Dias', {
      username: username,
      tokenContrato: tokenContrato,
      select: select,
    })
  },

  showProjecaoReceber15Dias: (username, tokenContrato, select) => {
    return http.post(route + 'showProjecaoReceber15Dias', {
      username: username,
      tokenContrato: tokenContrato,
      select: select,
    })
  },

  showProjecaoReceber30Dias: (username, tokenContrato, select) => {
    return http.post(route + 'showProjecaoReceber30Dias', {
      username: username,
      tokenContrato: tokenContrato,
      select: select,
    })
  },

  showProjecaoPagar7Dias: (username, tokenContrato, select) => {
    return http.post(route + 'showProjecaoPagar7Dias', {
      username: username,
      tokenContrato: tokenContrato,
      select: select,
    })
  },

  showProjecaoPagar15Dias: (username, tokenContrato, select) => {
    return http.post(route + 'showProjecaoPagar15Dias', {
      username: username,
      tokenContrato: tokenContrato,
      select: select,
    })
  },

  showProjecaoPagar30Dias: (username, tokenContrato, select) => {
    return http.post(route + 'showProjecaoPagar30Dias', {
      username: username,
      tokenContrato: tokenContrato,
      select: select,
    })
  },

  showMovimentacaoMensal: (username, tokenContrato, select) => {
    return http.post(route + 'showMovimentacaoMensal', {
      username: username,
      tokenContrato: tokenContrato,
      select: select,
    })
  },

  showMovimentacaoContas: (username, tokenContrato, select) => {
    return http.post(route + 'showMovimentacaoContas', {
      username: username,
      tokenContrato: tokenContrato,
      select: select,
    })
  },

  showMovimentacaoSemanalContas: (username, tokenContrato, select) => {
    return http.post(route + 'showMovimentacaoContasSemanal', {
      username: username,
      tokenContrato: tokenContrato,
      select: select,
    })
  },

  showJustificativaMovimentacao: (username, tokenContrato, select) => {
    return http.post(route + 'showJustificativaMovimentacao', {
      username: username,
      tokenContrato: tokenContrato,
      select: select,
    })
  },

  showRelatorioAnteiror: (username, tokenContrato, select) => {
    return http.post(route + 'showRelatorioAnteiror', {
      username: username,
      tokenContrato: tokenContrato,
      select: select,
    })
  },

  showDadosDelhamentoFinanceiro: (data, carteira, tokenContrato, select) => {
    return http.post(route + 'showDadosDelhamentoFinanceiro', {
      data: data,
      carteira: carteira,
      tokenContrato: tokenContrato,
      select: select,
    })
  },
}
